__turbopack_context__.v({
  "button": "hotline-modal-module-scss-module__bR5bOG__button",
  "button-desktop": "hotline-modal-module-scss-module__bR5bOG__button-desktop",
  "button-mobile": "hotline-modal-module-scss-module__bR5bOG__button-mobile",
  "placeholder": "hotline-modal-module-scss-module__bR5bOG__placeholder",
  "text": "hotline-modal-module-scss-module__bR5bOG__text",
});
